import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { List, Map, OrderedMap, fromJS } from 'immutable'
import { Button, Header, Grid, Segment, Loader, Icon, Table, Label, Checkbox, Modal } from 'semantic-ui-react'
import { SubeditorArea, SubeditorSplit, SubeditorBox, SubeditorPerson } from '~/common/subeditor'
import PeopleEdit from '~/people/views/edit'
import ConnectPerson from '../connectPerson'
import QueryString from 'query-string'
import moment from 'moment'
import Api from '~/api'
import EventLog from '~/event/log'

import Materials from './materials'
import Approval, { processApprovalInfo } from './approval'
import NoteEditor from '~/note'

class InterviewDetailsContainer extends PureComponent {
  render() {
    let {
      interview,
      location,
      history,
      mainTask,
      updateActiveInterview,
      project,
      createApprovalLoading,
      interviews,
      dispatch,
    } = this.props

    let people = interview.get('people', List())
    let materials = interview.getIn(['data', 'materials'], List())
    let approvals = interview.get('approvals', List())

    let locationQuery = QueryString.parse(location.search || '')
    let { editPerson = false } = locationQuery

    if (editPerson) editPerson = people.find(p => p.get('id') === editPerson)

    let { activeApproval, activeApprovalId, approvalGroups, activeApprovalGroupId, activeApprovalGroup } =
      processApprovalInfo(approvals)

    return (
      <Fragment>
        <SubeditorSplit columns={2}>
          <div>
            <SubeditorArea title="Haastattelun tiedot">
              {people.size ? (
                people.map(p => {
                  let fields = []
                  fields.push(['envelope outline', p.get('email', '')])
                  fields.push(['phone', p.getIn(['data', 'phone'], '')])
                  fields.push(['globe', p.get('lang')])

                  return (
                    <SubeditorPerson
                      key={p.get('id')}
                      name={p.getIn(['data', 'name'], '')}
                      fields={fields}
                      notes={p.getIn(['data', 'notes'], '')}
                      editLocation={Object.assign({}, location, { search: `editPerson=${p.get('id')}` })}
                    />
                  )
                })
              ) : (
                <SubeditorBox>Haastateltavia ei ole asetettu.</SubeditorBox>
              )}
              {mainTask.size ? (
                mainTask.map(t => {
                  let deadline = moment(t.get('deadline'), 'YYYY-MM-DD HH:mm:ss.SSSZZ')

                  let fields = []
                  // fields.push(['Aihe', t.getIn(['data', 'subject'], t.getIn(['data', '_task', 'name']))])
                  fields.push(['Ajankohta', deadline.format('DD.MM.YYYY - HH:mm')])
                  fields.push(['Vastuuhenkilö', t.get('user.name', t.getIn(['user', 'name']))])
                  fields.push(['Osoite', t.getIn(['data', 'coordinates', 'address'])])
                  fields.push(['Tarkennus', t.getIn(['data', 'coordinates', 'info'])])
                  fields.push(['Huomioita', t.getIn(['data', 'notes'])])

                  return (
                    <SubeditorBox key={t.get('id')} fields={fields}>
                      <div className="subeditor-box-actions">
                        <button
                          className="button-plain"
                          onClick={e => e.preventDefault() & dispatch({ type: 'PROJECT_EDIT_TASK', id: t.get('id') })}>
                          Muokkaa kuvausta
                        </button>
                      </div>
                    </SubeditorBox>
                  )
                })
              ) : (
                <SubeditorBox>Kuvausta ei ole asetettu.</SubeditorBox>
              )}
            </SubeditorArea>
          </div>
          <div>
            <SubeditorArea title="Haastattelun muistiinpanot">
              <NoteEditor
                entity="interview"
                entityId={interview.get('id')}
                type="production"
                relatedInterview={interview.get('id')}
              />
            </SubeditorArea>
            <SubeditorArea title="Projektin muistiinpanot">
              <NoteEditor
                entity="project"
                entityId={project.get('id')}
                type="production"
                relatedInterview={interview.get('id')}
              />
            </SubeditorArea>
            <SubeditorArea title="Organisaation muistiinpanot">
              <NoteEditor
                entity="organization"
                entityId={project.get('organization_id')}
                type="production"
                relatedInterview={interview.get('id')}
              />
            </SubeditorArea>
          </div>
          {editPerson ? (
            <ConnectPerson
              person={editPerson}
              edit
              task={mainTask.get(0, Map())}
              project={project}
              interviews={interviews}
              onClose={() => history.push(Object.assign({}, location, { search: '' }))}
            />
          ) : null}
        </SubeditorSplit>
        <SubeditorSplit columns={2}>
          <SubeditorArea title="Ladatut aineistot">
            <Materials
              updateMaterials={(materials, events = []) =>
                updateActiveInterview(interview.setIn(['data', 'materials'], materials), events)
              }
              interview={interview}
              materials={materials}
              history={history}
              location={location}
              activeApproval={activeApproval}
              activeApprovalGroup={activeApprovalGroup}
              locationQuery={locationQuery}
              dispatch={dispatch}
            />
          </SubeditorArea>
          <SubeditorArea title="Aineistojen hyväksytys">
            <Approval
              interview={interview}
              materials={materials}
              project={project}
              loading={false}
              items={approvals}
              approvalGroups={approvalGroups}
              activeApprovalGroupId={activeApprovalGroupId}
              activeApprovalGroup={activeApprovalGroup}
              creating={createApprovalLoading}
              activeApproval={activeApproval}
              activeApprovalId={activeApprovalId}
            />
          </SubeditorArea>
        </SubeditorSplit>
        <SubeditorArea title="Tapahtumat">
          <EventLog
            id={`interview_${interview.get('id')}`}
            filters={{ interview_id: interview.get('id') }}
            notes
            noteRelations={{
              interview_id: interview.get('id'),
              project_id: project.get('id'),
              organization_id: project.get('organization_id'),
            }}
          />
        </SubeditorArea>
      </Fragment>
    )
  }
}

export default withRouter(connect(() => ({}))(InterviewDetailsContainer))
